import * as React from "react";
const SvgFiRrChartNetwork = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chart-network_svg__a)">
      <path
        fill="#062147"
        d="M20 12a4 4 0 0 0-3.172 1.566l-.07-.03A5 5 0 0 0 10.75 7.16l-.09-.172a3.995 3.995 0 1 0-1.78.913l.073.137a4.99 4.99 0 0 0-1.134 6.7L5.933 16.5a4 4 0 1 0 1.455 1.378l1.838-1.718a4.99 4.99 0 0 0 6.54-.871l.278.119A4 4 0 1 0 20 12M6 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0M4 22a2 2 0 1 1 0-3.999 2 2 0 0 1 0 4m8-7a3 3 0 0 1-1.6-5.534l.407-.217A3 3 0 1 1 12 15.001m8 3a2 2 0 1 1 0-3.999 2 2 0 0 1 0 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chart-network_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChartNetwork;
